import type { CutsceneAssetV1 } from "@hyperlight/shared";

/**
 * SOUL kickoff finale (docs/design/soul-kickoff.md, beat 4): the walk home
 * ends at the living capital. Authored in a pilot-relative rig — the anchor is
 * the ARRIVING PLAYER's ground point, forward faces the capital ahead — so the
 * camera sweeps down the walk line and settles behind the pilot with home in
 * frame, never inside the town's massing. The beacon prompt follows the fade,
 * not the cutscene: arrival first, then the pull to put down roots.
 */
export const SOUL_REVEAL_CUTSCENE: CutsceneAssetV1 = {
  v: 1,
  id: "soul-reveal-v1",
  duration: 14,
  skippable: true,
  camera: [
    { t: 0, position: [-60, 220, -420], target: [0, 20, 200], fov: 60, ease: "smooth" },
    { t: 4, position: [-30, 90, -160], target: [0, 10, 120], fov: 54, ease: "smooth" },
    { t: 8, position: [10, 24, -60], target: [0, 4, 60], fov: 48, ease: "smooth" },
    { t: 11.5, position: [4, 3.5, -12], target: [0, 1.6, 8], fov: 46, ease: "ease-out" },
    { t: 14, position: [2.5, 2, -6.5], target: [0, 1.4, 4], fov: 56, ease: "smooth" },
  ],
  cues: [
    { start: 0.6, end: 4.4, eyebrow: "{capital}", text: "YOU MADE IT HOME." },
    { start: 5.6, end: 9.2, eyebrow: "SOMETHING ANSWERS", text: "THE SOUL LIGHTS UP" },
    { start: 10.2, end: 13.4, eyebrow: "IT WANTS GROUND OF ITS OWN", text: "STAKE YOUR FIRST CLAIM" },
  ],
};
